import { createSelector } from 'reselect';
import { getMetric } from '../../../Report/Report.selectors';
import ReportComponent from '../../../../utils/ReportComponent/ReportComponent';
import { resolveMetricsConfig } from '../../../../helpers/reportMetrics';

const reportUtils = ReportComponent.utils;

const location = (state) => state.routing?.location || state.routing?.locationBeforeTransitions || { query: {} };
const rows = (state) => state.statistics.data.rows;
const totals = (state) => state.statistics.data.totals;
const parameters = (state) => state.statistics.data.parameters;
const offers = (state) => state.offers.list;
const goals = (state) => state.goals.list;
const links = (state) => state.links.list;
const regions = (state) => state.regions.list;
const reportMetrics = (state) => state.serverStorage.store.report?.metrics || '';

export const getData = createSelector(
    rows,
    totals,
    parameters,
    offers,
    goals,
    links,
    regions,
    location,
    reportMetrics,
    (rows = [], totals = {}, parameters = {}, offers = [], goals = [], links = [], regions = [], location = {}, reportMetricsValue = '') => {
        const metricsConfig = resolveMetricsConfig(parameters, location, reportMetricsValue, reportUtils);
        let keysMetric = metricsConfig.keys;
        let data = [];

        if (Object.keys(totals).length) {
            data.push(keysMetric.map((key) => key === 'GroupBy' ? getMetric(key, totals[key], parameters, true) : totals[key]));
        }

        rows.map((item) => {
            data.push(keysMetric.map((key) => key === 'GroupBy' ? getMetric(key, item[key], parameters) : item[key]));
        });

        return data;
    }
);

export const getHeaderName = createSelector(
    parameters,
    location,
    reportMetrics,
    (parameters = {}, location = {}, reportMetricsValue = '') => {
        let list = [];

        const metricsConfig = resolveMetricsConfig(parameters, location, reportMetricsValue, reportUtils);
        let keysMetric = metricsConfig.keys;

        reportUtils.setKeyGroupBy(parameters.group_by);
        keysMetric.map((key) => {
            list.push(reportUtils.getTitleChain(key));
        });

        return list;
    }
);
